
  Vue.component('entity-category-selector', {
    props: {
      value: { type: Number, default: 9999 },
      visible: { type: Boolean, default: false }
    },
    data() {
      return {
        categories: [
          {
            id: 1,
            key: 'Company',
            message: 'Registrati ora',
            title: `Sei un'azienda ?`,
            image: '/Images/Aziende/intro2.png'
          },
          {
            id: 2,
            key: 'TrainingAgency',
            message: 'Entra nella nostra rete',
            title: `Sei un ente formativo ?`,
            image: '/Images/Formazione/intro.png'
          },
          {
            id: 3,
            key: 'WorkAgency',
            message: 'Trova i candidati adatti alle tue esigenze',
            title: `Sei un'agenzia per il lavoro`,
            image: '/Images/Agenzie/intro2.png'
          },
          {
            id: 5,
            key: 'VoluntaryAssociation',
            message: 'Entra nella nostra rete',
            title: `Sei un'associazione di volontariato&nbsp;?`,
            image: '/Images/LandingPages/Volontariato/intro2.png'
          }
        ]
      }
    },
    template: '#entity-category-selector',
    computed: {},
    watch: {},
    methods: {
      show() {}
    },
    mounted() {
      // EventBus.$on('vnShow', this.vnShow)
    },
    beforeDestroy() {
      // EventBus.$off('vnShow', this.vnShow)
    }
  })
